import React, { useState, useEffect } from "react";
import { RFIDReaderInput } from "rfid-reader-input";
import axios from "axios";
import "./scan.css";
import Navigation from "./Navigation";

// ── Three views: "scan" | "confirm" | "result"
function Rfid() {
  const [view, setView] = useState("scan");
  const [serialCard, setSerialcard] = useState("");
  const [openCardReaderWindow, setOpenCardReaderWindow] = useState(true);
  const [popupMessage, setPopupMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(null);

  // ── Active fields ──
  const [uid, setUid] = useState("");
  const [Firstname, setFirstname] = useState("");
  const [EmailAddress, setEmailAddress] = useState("");
  const [Ticket_Variant, setTicketVariant] = useState("");
  const [badgeType, setBadgeType] = useState("");
  const [RFID, setRFID] = useState("");
  const [qrCode, setQrCode] = useState("");
  const [sessionBooked, setSessionBooked] = useState([]);
  const [alreadyCheckedIn, setAlreadyCheckedIn] = useState(false);

  const [exhibitorId] = useState(
    JSON.parse(localStorage.getItem("token")).token,
  );
  const checkIn = true;

  // ✅ FIX 1: Correctly parse exhibitorName from localStorage
  const exhibitorName = JSON.parse(localStorage.getItem("token")).name;

  /* ─── helpers ─── */
  const clearUserState = () => {
    setUid("");
    setFirstname("");
    setEmailAddress("");
    setTicketVariant("");
    setBadgeType("");
    setRFID("");
    setQrCode("");
    setSessionBooked([]);
    setAlreadyCheckedIn(false);
    setSerialcard("");
    setOpenCardReaderWindow(true);
    setView("scan");
  };

  const fakeRFID = () => setSerialcard("0727222835");
  const handleCloseRFID = () => setOpenCardReaderWindow(false);

  /* ─── fetch user on scan ─── */
  const handlefetch = async (code) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN}/qrCode/getOneRFID?ticketId=${code}`,
      );
      if (!response.data) {
        setPopupMessage("User not found");
        setIsSuccess(false);
        setView("result");
        setTimeout(clearUserState, 2000);
        return;
      }
      const data = response.data;
      // console.log("Fetched ticket details:", data);
      setUid(data._id);
      setFirstname(data.Firstname || "");
      setEmailAddress(data.EmailAddress || data.Email || "");
      setTicketVariant(data.Ticket_Variant || "");
      setBadgeType(data.badgeType || "");
      setRFID(data.RFID || data.Reference_Number || "");
      setQrCode(data.qrCode || data.ticketId || "");
      setSessionBooked(data.sessionsBooked || []);
      setAlreadyCheckedIn(
        Array.isArray(data.checkedInByExhibitor) &&
        data.checkedInByExhibitor.includes(exhibitorId)
      );
      setView("confirm");
    } catch (error) {
      console.error("Error fetching ticket details:", error);
      setPopupMessage("Error fetching user details.");
      setIsSuccess(false);
      setView("result");
      setTimeout(clearUserState, 2000);
    }
  };

  /* ─── RFID scan handler ─── */
  let scanTimeout;
  const handleCodeCardRFID = (code) => {
    if (scanTimeout) clearTimeout(scanTimeout);
    scanTimeout = setTimeout(() => {
      setSerialcard(code);
      setOpenCardReaderWindow(false);
    }, 300);
  };

  useEffect(() => {
    if (serialCard) handlefetch(serialCard);
  }, [serialCard]);

  /* ─── user confirms YES ─── */
  const handleConfirmYes = async () => {
    const ticketDetails = {
      uid,
      Firstname,
      EmailAddress,
      Ticket_Variant,
      badgeType,
      RFID,
      qrCode,
      exhibitorId,
      checkIn,
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ADMIN}/qrCode/saveOneRFID`,
        ticketDetails,
      );
      setPopupMessage(response.data.message || "Checked in successfully.");
      setIsSuccess(true);
    } catch (error) {
      console.error("Error submitting:", error);
      setPopupMessage("Failed to check in.");
      setIsSuccess(false);
    }
    setView("result");
    setTimeout(clearUserState, 2500);
  };

  const handleConfirmNo = () => clearUserState();

  // ✅ FIX 2: Check if this exhibitor has a session booked with the attendee
  const hasSessionBooked = sessionBooked.includes(exhibitorName);

  const isSessionOnly = exhibitorName.toLowerCase().includes("session");

  // console.log("session only value : ", isSessionOnly);

  /* ════════════ RENDER ════════════ */
  return (
    <div style={S.root}>
      <div style={S.bgOrb1} />
      <div style={S.bgOrb2} />
      <div style={S.bgOrb3} />
      <style>{keyframes}</style>

      <div style={S.navWrapper}>
        <Navigation />
      </div>

      {openCardReaderWindow && view === "scan" && (
        <RFIDReaderInput
          isOpen={openCardReaderWindow}
          onRequestClose={handleCloseRFID}
          handleCodeCardRFID={handleCodeCardRFID}
        />
      )}

      {/* ══════════ VIEW: SCAN ══════════ */}
      {view === "scan" && (
        <div style={S.tapScreen}>
          <div style={{ ...S.ring, ...S.ring1 }} />
          <div style={{ ...S.ring, ...S.ring2 }} />
          <div style={{ ...S.ring, ...S.ring3 }} />

          <div style={S.glowDisc}>
            <div style={S.rfidIconWrapper}>
              <svg style={S.rfidIcon} viewBox="0 0 80 56" fill="none">
                <rect
                  x="1"
                  y="1"
                  width="78"
                  height="54"
                  rx="8"
                  stroke="#e81b23"
                  strokeWidth="2"
                  fill="rgba(232,27,35,0.06)"
                />
                <rect
                  x="10"
                  y="18"
                  width="18"
                  height="20"
                  rx="3"
                  stroke="#e81b23"
                  strokeWidth="1.5"
                  fill="rgba(232,27,35,0.1)"
                />
                <line x1="10" y1="25" x2="28" y2="25" stroke="#e81b23" strokeWidth="1" opacity="0.6" />
                <line x1="10" y1="31" x2="28" y2="31" stroke="#e81b23" strokeWidth="1" opacity="0.6" />
                <line x1="17" y1="18" x2="17" y2="38" stroke="#e81b23" strokeWidth="1" opacity="0.6" />
                <line x1="21" y1="18" x2="21" y2="38" stroke="#e81b23" strokeWidth="1" opacity="0.6" />
                <path d="M42 28C42 28 46 24 46 28C46 32 42 28 42 28Z" fill="rgba(232,27,35,0.5)" />
                <path d="M40 20C46 20 52 24 52 28C52 32 46 36 40 36" stroke="#e81b23" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.8" />
                <path d="M40 13C50 13 58 20 58 28C58 36 50 43 40 43" stroke="#e81b23" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.5" />
                <path d="M40 6C54 6 64 16 64 28C64 40 54 50 40 50" stroke="#e81b23" strokeWidth="1.2" strokeLinecap="round" fill="none" opacity="0.25" />
              </svg>
            </div>

            <div style={S.tapTextWrapper}>
              <p style={S.tapLabel}>TAP YOUR</p>
              <p style={S.tapMain}>RFID CARD</p>
              <div style={S.tapDivider} />
              <p style={S.tapSub}>Hold card near the reader</p>
            </div>

            <div style={S.scanBar}>
              <div style={S.scanBarInner} />
            </div>
          </div>

          <button onClick={fakeRFID} style={S.fakeBtn} />
        </div>
      )}

      {/* ══════════ VIEW: CONFIRM ══════════ */}
      {view === "confirm" && (
        <div style={S.confirmScreen}>
          <div style={S.confirmCard}>
            <div style={S.confirmHeader}>
              <div style={S.avatarRing}>
                <span style={S.avatarLetter}>
                  {Firstname ? Firstname.charAt(0).toUpperCase() : "?"}
                </span>
              </div>
              <div style={{ minWidth: 0 }}>
                <p style={S.confirmSubtitle}>RFID Detected</p>
                <p style={S.confirmName}>{Firstname || "Unknown Attendee"}</p>
              </div>
            </div>

            <div style={S.divider} />

            {alreadyCheckedIn && (
              <div style={S.warningBanner}>
                <span style={S.warningIcon}>⚠</span>
                <span style={S.warningText}>
                  This attendee is already checked in
                </span>
              </div>
            )}

            <div style={S.dataGrid}>
              <DataRow label="Email" value={EmailAddress} />
              <DataRow label="Ticket Variant" value={Ticket_Variant} />
              <DataRow label="Badge Type" value={badgeType} highlight />
              <DataRow label="RFID" value={RFID} mono />
            </div>

            <div style={S.divider} />

            <div style={S.Infodiv}>

            <p style={S.sessionName}>
             {exhibitorName}
            </p>

            {/* ✅ FIX 3: Session status message driven by hasSessionBooked */}
            {isSessionOnly ? (
            <p style={S.confirmQuestion}>
              {hasSessionBooked ? (
                <>
                  This attendee has a <span style={S.textHighlight1}>booked session</span> with you.
                </>
              ) : (
                <>
                  This attendee has <span style={S.textHighlight2}>no session booked</span> with you.
                </>
              )}
            </p>
            ): (
              <p style={S.confirmQuestion}>
                  This Check In is <span style={S.textHighlight1}>open for all</span>.
              </p>
            )}
            <p style={S.confirmSubtitle2}>
              {alreadyCheckedIn
                ? "Re-check this attendee in?"
                : "Confirm check-in for this attendee?"}
            </p>

            </div>

            {/* ✅ FIX 4: Only show active Check In button if session is booked */}
            <div style={S.btnRow}>
              <button
                style={S.btnNo}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = S.btnNo.background;
                  e.currentTarget.style.borderColor = "rgba(255,255,255,0.12)";
                }}
                onClick={handleConfirmNo}
              >
                <span style={S.btnIconNo}>✕</span> No, Cancel
              </button>

              {hasSessionBooked || !isSessionOnly ? (
                <button
                  style={S.btnYes}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.filter = "brightness(1.15)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.filter = "";
                    e.currentTarget.style.transform = "";
                  }}
                  onClick={handleConfirmYes}
                >
                  <span style={S.btnIconYes}>✓</span> Yes, Check In
                </button>
              ) : (
                <button
                  style={S.btnYesDisabled}
                  disabled
                >
                  <span style={S.btnIconYes}>✕</span> No Session Booked
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ══════════ VIEW: RESULT ══════════ */}
      {view === "result" && (
        <div style={S.resultScreen}>
          <div
            style={{
              ...S.resultCard,
              background: isSuccess
                ? "linear-gradient(135deg,#0d2818 0%,#0a1f12 100%)"
                : "linear-gradient(135deg,#2a0a0a 0%,#1a0505 100%)",
              borderColor: isSuccess
                ? "rgba(74,222,128,0.4)"
                : "rgba(232,27,35,0.4)",
              boxShadow: isSuccess
                ? "0 0 40px rgba(74,222,128,0.2),0 16px 48px rgba(0,0,0,0.6)"
                : "0 0 40px rgba(232,27,35,0.25),0 16px 48px rgba(0,0,0,0.6)",
            }}
          >
            <div
              style={{
                ...S.resultIcon,
                background: isSuccess
                  ? "rgba(74,222,128,0.15)"
                  : "rgba(232,27,35,0.15)",
                border: `2px solid ${isSuccess ? "rgba(74,222,128,0.5)" : "rgba(232,27,35,0.5)"}`,
                color: isSuccess ? "#4ade80" : "#f87171",
              }}
            >
              {isSuccess ? "✓" : "✕"}
            </div>
            <p
              style={{
                ...S.resultMsg,
                color: isSuccess ? "#4ade80" : "#f0f0f5",
              }}
            >
              {popupMessage}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

/* ── Reusable data row ── */
function DataRow({ label, value, highlight, mono }) {
  return (
    <div style={S.dataRow}>
      <span style={S.dataLabel}>{label}</span>
      {label === "QR Code" ? (
        <div style={S.qrImageWrap}>
          {value && (
            <img
              src={value}
              alt="QR Code"
              width={100}
              height={100}
              style={{ display: "block", borderRadius: 8 }}
            />
          )}
        </div>
      ) : (
        <span
          style={{
            ...S.dataValue,
            ...(highlight ? S.dataHighlight : {}),
            ...(mono ? S.dataMono : {}),
          }}
        >
          {value || <span style={S.dataEmpty}>—</span>}
        </span>
      )}
    </div>
  );
}

/* ─────────── Keyframes ─────────── */
const keyframes = `
  @keyframes orbFloat1{0%,100%{transform:translate(0,0) scale(1)}33%{transform:translate(60px,-80px) scale(1.15)}66%{transform:translate(-40px,40px) scale(0.9)}}
  @keyframes orbFloat2{0%,100%{transform:translate(0,0) scale(1)}33%{transform:translate(-70px,50px) scale(1.1)}66%{transform:translate(50px,-60px) scale(0.95)}}
  @keyframes orbFloat3{0%,100%{transform:translate(0,0) scale(1)}50%{transform:translate(40px,60px) scale(1.2)}}
  @keyframes cardFloat{0%,100%{transform:translateY(0px) rotate(-1deg)}50%{transform:translateY(-18px) rotate(1deg)}}
  @keyframes ripple{0%{transform:scale(0.7);opacity:0.6}100%{transform:scale(2.6);opacity:0}}
  @keyframes glowPulse{0%,100%{box-shadow:0 0 40px rgba(232,27,35,0.25),0 0 80px rgba(232,27,35,0.1)}50%{box-shadow:0 0 70px rgba(232,27,35,0.45),0 0 120px rgba(232,27,35,0.2)}}
  @keyframes scanSlide{0%{left:-60%;opacity:0}10%{opacity:1}90%{opacity:1}100%{left:110%;opacity:0}}
  @keyframes fadeSlideUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
  @keyframes labelBlink{0%,100%{opacity:0.5}50%{opacity:1}}
  @keyframes confirmIn{from{opacity:0;transform:translateY(32px) scale(0.96)}to{opacity:1;transform:translateY(0) scale(1)}}
  @keyframes resultPop{0%{opacity:0;transform:scale(0.8)}70%{transform:scale(1.04)}100%{opacity:1;transform:scale(1)}}
`;

/* ─────────── Styles ─────────── */
const vw = typeof window !== "undefined" ? window.innerWidth : 1024;
const isMobile = vw < 480;
const isTablet = vw >= 480 && vw < 768;
const isSmall = vw < 768;

const S = {
  root: {
    position: "relative",
    inset: 0,
    background: "linear-gradient(160deg,#0a0a0f 0%,#12121a 40%,#0d0d15 100%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    minHeight: "100vh",
    overflowX: "hidden",
  },
  navWrapper: {
    width: "98%",
    padding: "10px 0",
    zIndex: 10,
    position: "relative",
  },
  bgOrb1: {
    position: "fixed",
    top: "-15%",
    left: "-10%",
    width: isMobile ? 300 : 600,
    height: isMobile ? 300 : 600,
    borderRadius: "50%",
    background: "radial-gradient(circle,rgba(232,27,35,0.18) 0%,rgba(232,27,35,0.04) 50%,transparent 70%)",
    animation: "orbFloat1 12s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 0,
    filter: "blur(8px)",
  },
  qrImageWrap: {
    background: "#fff",
    borderRadius: "10px",
    padding: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 0,
  },
  bgOrb2: {
    position: "fixed",
    bottom: "-20%",
    right: "-10%",
    width: isMobile ? 300 : 700,
    height: isMobile ? 300 : 700,
    borderRadius: "50%",
    background: "radial-gradient(circle,rgba(180,10,18,0.14) 0%,rgba(120,0,10,0.05) 50%,transparent 70%)",
    animation: "orbFloat2 16s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 0,
    filter: "blur(12px)",
  },
  bgOrb3: {
    position: "fixed",
    top: "40%",
    left: "30%",
    width: isMobile ? 200 : 400,
    height: isMobile ? 200 : 400,
    borderRadius: "50%",
    background: "radial-gradient(circle,rgba(255,80,80,0.06) 0%,transparent 70%)",
    animation: "orbFloat3 20s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 0,
    filter: "blur(20px)",
  },

  /* ── SCAN VIEW ── */
  tapScreen: {
    position: "relative",
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
    padding: isMobile ? "24px 16px" : "32px 24px",
    boxSizing: "border-box",
  },
  ring: {
    position: "absolute",
    borderRadius: "50%",
    border: "1.5px solid rgba(232,27,35,0.5)",
    pointerEvents: "none",
  },
  ring1: {
    width: isMobile ? 180 : 260,
    height: isMobile ? 180 : 260,
    animation: "ripple 3s ease-out infinite",
  },
  ring2: {
    width: isMobile ? 180 : 260,
    height: isMobile ? 180 : 260,
    animation: "ripple 3s ease-out infinite 1s",
  },
  ring3: {
    width: isMobile ? 180 : 260,
    height: isMobile ? 180 : 260,
    animation: "ripple 3s ease-out infinite 2s",
  },
  glowDisc: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: isMobile ? "16px" : "24px",
    padding: isMobile ? "32px 24px" : isTablet ? "40px 40px" : "48px 56px",
    borderRadius: "28px",
    background: "rgba(14,14,20,0.75)",
    border: "1px solid rgba(232,27,35,0.2)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    animation: "glowPulse 3s ease-in-out infinite",
    zIndex: 3,
    width: "100%",
    maxWidth: isMobile ? "100%" : "420px",
    minWidth: "unset",
    boxSizing: "border-box",
  },
  rfidIconWrapper: {
    animation: "cardFloat 3.5s ease-in-out infinite",
    filter: "drop-shadow(0 0 16px rgba(232,27,35,0.5))",
  },
  rfidIcon: {
    width: isMobile ? 90 : isTablet ? 110 : 140,
    height: "auto",
  },
  tapTextWrapper: {
    textAlign: "center",
    animation: "fadeSlideUp 0.8s ease-out",
  },
  tapLabel: {
    margin: 0,
    fontSize: isMobile ? "11px" : "13px",
    fontWeight: 600,
    letterSpacing: "0.25em",
    color: "rgba(180,180,200,0.5)",
    animation: "labelBlink 2.5s ease-in-out infinite",
    textTransform: "uppercase",
  },
  tapMain: {
    margin: "6px 0 0 0",
    fontSize: isMobile ? "28px" : isTablet ? "34px" : "42px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    color: "#f0f0f5",
    textShadow: "0 0 30px rgba(232,27,35,0.6),0 2px 8px rgba(0,0,0,0.6)",
    lineHeight: 1.1,
    textTransform: "uppercase",
  },
  tapDivider: {
    width: "60px",
    height: "2px",
    background: "linear-gradient(90deg,transparent,#e81b23,transparent)",
    borderRadius: "2px",
    margin: "12px auto",
  },
  tapSub: {
    margin: 0,
    fontSize: isMobile ? "11px" : "13px",
    color: "rgba(180,180,200,0.45)",
    letterSpacing: "0.08em",
    fontStyle: "italic",
  },
  scanBar: {
    position: "relative",
    width: isMobile ? "160px" : "220px",
    height: "3px",
    borderRadius: "3px",
    background: "rgba(255,255,255,0.06)",
  },
  scanBarInner: {
    position: "absolute",
    top: 0,
    width: "60px",
    height: "100%",
    borderRadius: "3px",
    background: "linear-gradient(90deg,transparent,#e81b23,transparent)",
    boxShadow: "0 0 10px rgba(232,27,35,0.8)",
    animation: "scanSlide 2s linear infinite",
  },
  fakeBtn: {
    opacity: 0,
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "10%",
    height: "10%",
    cursor: "default",
    border: "none",
    background: "none",
  },

  /* ── CONFIRM VIEW ── */
  confirmScreen: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    zIndex: 2,
    padding: isMobile ? "16px 12px 24px" : "24px 20px",
    boxSizing: "border-box",
    overflowY: "auto",
  },
  confirmCard: {
    background: "rgba(14,14,20,0.92)",
    backdropFilter: "blur(30px)",
    WebkitBackdropFilter: "blur(30px)",
    border: "1px solid rgba(232,27,35,0.25)",
    borderRadius: "24px",
    boxShadow: "0 8px 48px rgba(0,0,0,0.6),inset 0 1px 0 rgba(255,255,255,0.06)",
    padding: isMobile ? "24px 20px" : isTablet ? "28px 28px" : "36px 40px",
    width: "100%",
    maxWidth: "500px",
    animation: "confirmIn 0.45s cubic-bezier(0.22,1,0.36,1)",
    boxSizing: "border-box",
  },
  confirmHeader: {
    display: "flex",
    alignItems: "center",
    gap: isMobile ? "14px" : "20px",
    marginBottom: "4px",
  },
  avatarRing: {
    width: isMobile ? 48 : 64,
    height: isMobile ? 48 : 64,
    borderRadius: "50%",
    flexShrink: 0,
    border: "2px solid rgba(232,27,35,0.6)",
    background: "rgba(232,27,35,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 20px rgba(232,27,35,0.3)",
  },
  avatarLetter: {
    fontSize: isMobile ? "20px" : "28px",
    fontWeight: 800,
    color: "#e81b23",
    textShadow: "0 0 16px rgba(232,27,35,0.6)",
  },
  Infodiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
  },

  textHighlight1: {
    color: "#0aff64",
    fontWeight: 700,
  },

  textHighlight2: {
    color: "#e81b23",
    fontWeight: 700,
  },

  sessionName: {
    width: "60%",
    margin: "2px auto",
    textAlign: "center",
    fontSize: isMobile ? "12px" : "14px",
    fontWeight: 600,
    letterSpacing: "0.1em",
    // color: "rgba(180,180,200,0.5)",
    textTransform: "uppercase",
    color: "#e81b23",
    background: "rgba(232,27,35,0.1)",
    border: "1px solid rgba(232,27,35,0.25)",
    borderRadius: "10px",
    padding: "4px 8px",
  },
  confirmSubtitle: {
    margin: "0 auto",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.2em",
    color: "rgba(180,180,200,0.45)",
    textTransform: "uppercase",
  },
  confirmSubtitle2: {
    margin: "0",
    fontSize: isMobile ? "11px" : "13px",
    fontWeight: 600,
    letterSpacing: "0.02em",
    color: "rgba(180,180,200,0.45)",
    textAlign: "center",
    textTransform: "uppercase",
  },
  confirmName: {
    margin: "4px 0 0 0",
    fontSize: isMobile ? "18px" : isTablet ? "22px" : "26px",
    fontWeight: 800,
    color: "#f0f0f5",
    letterSpacing: "0.03em",
    textShadow: "0 0 20px rgba(232,27,35,0.3)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: isMobile ? "200px" : "300px",
  },
  divider: {
    height: "1px",
    background: "rgba(255,255,255,0.07)",
    margin: isMobile ? "10px 0" : "12px 0",
  },
  warningBanner: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: "rgba(250,200,0,0.08)",
    border: "1px solid rgba(250,200,0,0.25)",
    borderRadius: "10px",
    padding: "10px 16px",
    marginBottom: "16px",
  },
  warningIcon: { fontSize: "16px", color: "#facc15" },
  warningText: {
    fontSize: isMobile ? "12px" : "13px",
    fontWeight: 600,
    color: "#facc15",
    letterSpacing: "0.02em",
  },
  dataGrid: {
    display: "flex",
    flexDirection: "column",
    gap: isMobile ? "6px" : "8px",
  },
  dataRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "rgba(255,255,255,0.04)",
    borderRadius: "10px",
    padding: isMobile ? "8px 12px" : "10px 16px",
    border: "1px solid rgba(255,255,255,0.06)",
    gap: "8px",
  },
  dataLabel: {
    fontSize: isMobile ? "10px" : "12px",
    fontWeight: 600,
    color: "rgba(180,180,200,0.5)",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
    flexShrink: 0,
  },
  dataValue: {
    fontSize: isMobile ? "12px" : "14px",
    fontWeight: 600,
    color: "#f0f0f5",
    textAlign: "right",
    maxWidth: "60%",
    wordBreak: "break-all",
  },
  dataHighlight: {
    color: "#e81b23",
    background: "rgba(232,27,35,0.1)",
    border: "1px solid rgba(232,27,35,0.25)",
    borderRadius: "6px",
    padding: "2px 8px",
    fontSize: isMobile ? "11px" : "13px",
  },
  dataMono: {
    fontFamily: "monospace",
    fontSize: isMobile ? "10px" : "12px",
    color: "rgba(200,200,220,0.7)",
  },
  dataEmpty: { color: "rgba(180,180,200,0.25)", fontStyle: "italic" },
  confirmQuestion: {
    margin: "0 0 4px 0",
    textAlign: "center",
    fontSize: isMobile ? "13px" : "15px",
    fontWeight: 700,
    color: "rgba(240,240,245,0.8)",
    letterSpacing: "0.02em",
  },
  btnRow: {
    display: "flex",
    gap: isMobile ? "10px" : "14px",
    marginTop: isMobile ? "14px" : "20px",
    flexDirection: isMobile && vw < 360 ? "column" : "row",
  },
  btnNo: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "12px",
    padding: isMobile ? "12px 0" : "14px 0",
    cursor: "pointer",
    color: "rgba(200,200,210,0.8)",
    fontWeight: 700,
    fontSize: isMobile ? "13px" : "15px",
    letterSpacing: "0.03em",
    transition: "all 0.25s ease",
    outline: "none",
    borderColor: "rgba(255,255,255,0.12)",
  },
  btnYes: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    background: "linear-gradient(135deg,#e81b23 0%,#c8121a 100%)",
    border: "none",
    borderRadius: "12px",
    padding: isMobile ? "12px 0" : "14px 0",
    cursor: "pointer",
    color: "#fff",
    fontWeight: 800,
    fontSize: isMobile ? "13px" : "15px",
    letterSpacing: "0.03em",
    boxShadow: "0 4px 20px rgba(232,27,35,0.45)",
    transition: "all 0.25s ease",
    outline: "none",
  },
  // ✅ NEW: Disabled state style for when no session is booked
  btnYesDisabled: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "12px",
    padding: isMobile ? "12px 0" : "14px 0",
    cursor: "not-allowed",
    color: "rgba(200,200,210,0.3)",
    fontWeight: 700,
    fontSize: isMobile ? "13px" : "15px",
    letterSpacing: "0.03em",
    outline: "none",
    opacity: 0.5,
  },
  btnIconNo: { fontSize: isMobile ? "13px" : "15px" },
  btnIconYes: { fontSize: isMobile ? "13px" : "15px" },

  /* ── RESULT VIEW ── */
  resultScreen: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
    padding: isMobile ? "24px 16px" : "32px 20px",
    boxSizing: "border-box",
  },
  resultCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: isMobile ? "14px" : "20px",
    padding: isMobile ? "36px 28px" : isTablet ? "44px 48px" : "52px 64px",
    borderRadius: "28px",
    border: "1px solid",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    animation: "resultPop 0.45s cubic-bezier(0.22,1,0.36,1)",
    width: "100%",
    maxWidth: "420px",
    boxSizing: "border-box",
  },
  resultIcon: {
    width: isMobile ? 52 : 64,
    height: isMobile ? 52 : 64,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: isMobile ? "24px" : "30px",
    fontWeight: 800,
  },
  resultMsg: {
    margin: 0,
    fontSize: isMobile ? "17px" : "22px",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textAlign: "center",
  },
};

export default Rfid;